export const HTML_ATTR_REPLACE_VAR = 'data-sc-var';
export const HTML_ATTR_ACTION = 'data-sc-action';
export const HTML_ATTR_RENDERIF = 'data-sc-render';
export const HTML_ATTR_INPUT = 'data-sc-input';

export const HTML_CLASS_HIDE_ELEMENT = 'sc-hidden';

export const HTML_PURCHASE_CHECKOUT_IDS = {
  container: 'sc-checkout-container',
  form: 'sc-checkout-form',
  invoicecountry: 'sc-checkout-invoicecountry',
  errorContainer: 'sc-checkout-globalerror',
  processingContainer: 'sc-checkout-processing',
  formContainer: 'sc-checkout-formcontainer',
  card: {
    number: 'sc-checkout-card-number',
    name: 'sc-checkout-card-name',
    submit: 'sc-checkout-card-submit',
  },
  sepa: {
    iban: 'sc-checkout-sepa-iban',
    name: 'sc-checkout-sepa-name',
    bank: 'sc-checkout-sepa-bank',
    submit: 'sc-checkout-sepa-submit',
  },
  sofort: {
    name: 'sc-checkout-sofort-name',
    submit: 'sc-checkout-sofort-submit',
  },
};

export const HTML_PURCHASE_CHECKOUT_VERIFY_IDS = {
  errorContainer: 'sc-checkoutverify-error',
};
